import React, { useState, useEffect } from "react";
import ReactDropdown from "react-dropdown";
import { DanhSachTaiSanCombo } from "constants/danhSachTaiSanConst";
import { SearchTaiSan } from "./SearchNangCao/SearchTaiSan";
import { useSelector, useDispatch } from "react-redux";
import { getListTaiSan, updateDataSearch } from "actions/DanhSachTaiSan/";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import StoreApi from "service/storeApi";
import CauHinhApi from "service/cauHinhApi";
import cauHinh from "utils/cauHinh";

const trangThaiTaiSanTraGop = { value: "13", label: "Đang trả góp" };

export const SearchBar = () => {
  const [show, setShow] = useState(false);
  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);
  const [trangThaiTaiSanCombo, setTrangThaiTaiSanCombo] = useState(
    DanhSachTaiSanCombo.TrangThaiTaiSanCombo,
  );
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTaiSan); //dataSearchTaiSan dinh nghia o rootreducer

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const initStore = {
  //   objComboStore: [],
  // };

  // const [stores] = useState(initStore);
  useEffect(() => {
    StoreApi.combo({}).then((response) => {
      // console.log(response.data);
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.StoreName,
      }));
      //setdataCombo(dataComboReturn);
      setdataCombo([
        {
          value: 0,
          label: "Kho",
        },
        ...dataComboReturn,
      ]);
    });

    const params = new URLSearchParams(window.location.search);
    const status = params.get("Type");
    if (status === "7") {
      DanhSachTaiSanCombo.TrangThaiTaiSanDefault = "7";
    }

    CauHinhApi.getConfigSys1().then((response) => {
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        const configCauHinhT77 = response.data.find(
          (e) =>
            e.keyConfig &&
            e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsCauHinhT77.toUpperCase(),
        );
        if (configCauHinhT77 && configCauHinhT77.valueConfig === "1") {
          setTrangThaiTaiSanCombo([
            ...DanhSachTaiSanCombo.TrangThaiTaiSanCombo,
            trangThaiTaiSanTraGop,
          ]);
        }
      }
    });
  }, []);

  const updateState = (field, value) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: value,
      }),
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const updateDropdown1 = (field) => (e) => {
    updateState(field, e.value);
  };

  const onSearch = () => {
    //console.log(dataSearch.selectOption);
    //alert(fdataSearch.selectOption);
    // const dataSearchFormat = {
    //   customerName: dataSearch.searchText,
    //   phone: dataSearch.searchText,
    //   dateFrom: formatDayMonth(dataSearch.dateFrom),
    //   dateTo: formatDayMonth(dataSearch.dateTo),
    //   status: dataSearch.status,
    //   pageIndex: dataSearch.pageIndex,
    //   pageSize: dataSearch.pageSize,
    // };
    //console.log(dataSearchFormat);
    // console.log(dataSearch);
    dispatch(getListTaiSan(dataSearch));
    //dispatch(getListNhanVay(dataSearchFormat));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        }),
      );
      dispatch(getListTaiSan(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  return (
    <div className="search-new hidden-mobile-main show-table-main ">
      <div className="input-sm-new input-new-18 ">
        <input
          name="mataisan"
          className="form-control input-sm"
          placeholder="Mã tài sản"
          onChange={updateTextValue("mataisan")}
          onKeyDown={handleKeyDown}
          value={dataSearch.mataisan}
        />
      </div>
      <div className="input-sm-new input-new-18">
        <input
          name="tentaisan"
          className="form-control input-sm"
          placeholder="Tên tài sản"
          onChange={updateTextValue("tentaisan")}
          onKeyDown={handleKeyDown}
          value={dataSearch.tentaisan}
        />
      </div>

      <div className="input-sm-new input-new-18">
        <input
          name="tenkhachhang"
          className="form-control input-sm"
          placeholder="Tên khách hàng"
          onChange={updateTextValue("tenkhachhang")}
          onKeyDown={handleKeyDown}
          value={dataSearch.tenkhachhang}
        />
      </div>

      <div className="input-sm-new input-new-18">
        {/* <ReactDropdown
          options={dataCombo}
          value={dataSearch.kho}
          onChange={updateDropdown("kho")}
          name="kho"
          controlClassName="form-control input-sm"
          placeholder="- Kho -"
        /> */}
        <select
          name="kho"
          className="selectBox form-control input-sm"
          value={dataSearch.kho}
          onChange={updateDropdown("kho")}
        >
          {dataCombo &&
            dataCombo.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>

      <div className="input-sm-new input-new-18">
        <ReactDropdown
          options={trangThaiTaiSanCombo}
          onChange={updateDropdown1("trangthai")}
          name="trangthai"
          controlClassName="form-control input-sm"
          placeholder="Trạng thái"
          value={DanhSachTaiSanCombo.TrangThaiTaiSanDefault}
          // value={dataSearch.trangthai === 0 ? -1 : dataSearch.trangthai}
        />
      </div>

      <div className="input-sm-new input-new-14 search-main-new">
        <button
          type="submit"
          className="btn btn-info-new"
          // style={{ paddingTop: "7px" }}
          onClick={onSearch}
        >
          <i className="la la-search"></i>
          <span className="search-label"> &nbsp; Tìm kiếm</span>
        </button>
      </div>
      <div className="input-sm-search-adv" style={{ width: "5%" }}>
        <button
          type="submit"
          className="btn btn-search-adv-new"
          onClick={handleShow}
        >
          <img src="/app-assets/images/icon-loc-v21.png" />
        </button>
      </div>

      <SearchTaiSan
        show={show}
        onHide={handleClose}
        trangThaiTaiSanCombo={trangThaiTaiSanCombo}
      />
    </div>
  );
};
